import $ from 'jquery';
// import cssClasses from '../helpers/cssClasses';

export default () => {
  function init() {
    setEventListeners();
    // hideOnLoad();
    // $('#shades--nav li:first-child').addClass('active');
    $('.skintone--shade__stepTwo').hide();
  }

  function setEventListeners() {
    $('#shades--nav li').on('click', function (ev) {
      ev.preventDefault();
      $('#shades--nav li').removeClass('active');
      $(this).addClass('active');

      $('.skintone--shade__stepTwo').hide();

      const activeTab = $(this).find('a').attr('href');
      console.log(`Active Tab:${activeTab}`);
      $(activeTab).fadeIn();

      return false;
    });
  }

  return Object.freeze({
    init,
  });
};